module.exports = __webpack_public_path__ + "dist/media/logo--de.6b5dd291.svg";